import { TimeService } from '@festina/moneyin-general-types/moneyin-test/services/TimeService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = TimeService.timeServicePostSetTime
type MethodParam = Parameters<typeof method>[0]

export const useSubmitMoneyInTime = () =>
  useFestinaMutation({
    component: 'moneyIn',
    isScenario: false,
    roles: TimeService.timeServicePostSetTime_roles,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ ...arg }),
  })
